import { jsx as _jsx } from "react/jsx-runtime";
import arrow from './image/arrow.svg';
import s from './Modal.module.scss';
export const CloseBnt = ({ close, styleName }) => {
    return (_jsx("button", Object.assign({ type: "button", className: `${s.btn_close} ${styleName}`, "aria-label": "button go back", onClick: close }, { children: _jsx("img", { src: arrow, alt: "arrow back", className: s.icon }) })));
};
